export const generateTimeSlots = (
    day,
    startTime, // "HH:mm"
    endTime, // "HH:mm"
    duration = 60, // minutos
) => {
    // "HH:mm" -> minutes from 00:00 (0..1439)
    const toMinutes = time => {
        const [h, m] = time.split(":").map(Number);
        return (h * 60 + (m || 0)) % 1440;
    };

    // minutes -> "HH:mm" with wrap a 24h
    const fmt = totalMins => {
        const mins = ((totalMins % 1440) + 1440) % 1440;
        const h = Math.floor(mins / 60);
        const m = mins % 60;
        const pad = n => n.toString().padStart(2, "0");
        return `${pad(h)}:${pad(m)}`;
    };

    const startM = toMinutes(startTime);
    let endM = toMinutes(endTime);

    // if end <= start, We assume the shift crosses midnight
    // or what a shift is of 24h (when start === end).
    if (endM <= startM) endM += 1440;

    const totalMinutes = endM - startM;
    if (totalMinutes <= 0 || duration <= 0) return [];

    // Calculate number of slots
    const slotCount = Math.max(1, Math.round(totalMinutes / duration));
    const baseDuration = Math.floor(totalMinutes / slotCount);
    const extraMinutes = totalMinutes % slotCount;

    const slots = [];
    let cursor = startM;

    for (let i = 0; i < slotCount; i++) {
        const slotStart = cursor;
        const minutes = baseDuration + (i < extraMinutes ? 1 : 0);
        cursor += minutes;
        const slotEnd = cursor;

        // cutoff: 30 minutes before the end of the slot
        const cutoff = slotEnd - 30;

        slots.push({
            start: fmt(slotStart),
            end: fmt(slotEnd),
            is_express: false,
            cutoff_time: fmt(cutoff),
            disable_for_today: false,
            disable: false,
            day_of_the_week: day,
        });
    }

    return slots;
};

/**
 * Converts "HH:MM" into minutes from 00:00. Returns null on invalid input.
 */
export const toMinutes = hhmm => {
    if (!hhmm || typeof hhmm !== "string") return 0;
    const [h, m] = hhmm.split(":").map(Number);
    if (Number.isNaN(h) || Number.isNaN(m)) return 0;
    return h * 60 + m;
};

export const normalizeTimeSlots = (slots, workingHourStart) => {
    if (!Array.isArray(slots)) return [];

    const whStartMin = toMinutes(workingHourStart);

    const align = (mins, base) =>
        isFiniteNum(mins) ? (mins < base ? mins + 1440 : mins) : NaN;

    return slots
        .map((s, idx) => {
            const rs = toMinutes(s?.start);
            const re = toMinutes(s?.end);
            if (!Number.isFinite(rs) || !Number.isFinite(re)) return null;

            const start = align(rs, whStartMin);
            let end = align(re, whStartMin);
            if (end <= start) end += 1440;

            return { idx, start, end };
        })
        .filter(Boolean)
        .sort((a, b) => a.start - b.start);
};

export const isFiniteNum = n => typeof n === "number" && Number.isFinite(n);

// New feature: Detect shifts that cross midnight
export const isOvernightShift = (start, end) => {
    if (!start || !end) return false;
    const startMin = toMinutes(start);
    const endMin = toMinutes(end);
    return endMin <= startMin; // if end <= start, crosses midnight
};

// Map a time (minutes) to the shift timeline
// Base = start of the shift (ej. workingHours.start o slot.start).
export const alignToBase = (mins, base) => {
    if (!isFiniteNum(mins)) return NaN;
    // If the time is "before" the start of the shift, add 24h
    return mins < base ? mins + 1440 : mins;
};
